import { Reveal } from "@/components/Reveal";
import { Building2, Target, Handshake } from "lucide-react";

const CHAPTERS = [
  {
    num: "01",
    icon: Building2,
    title: "Post",
    body: "List a property or a live client search in under two minutes. Price bands, areas and dates.",
  },
  {
    num: "02",
    icon: Target,
    title: "Match",
    body: "The matching engine pairs your post with relevant opportunities from verified agents — in your own city and internationally.",
  },
  {
    num: "03",
    icon: Handshake,
    title: "Split commission",
    body: "Negotiate the fee split directly in-app before any introduction is made. Terms are agreed in writing, then both sides proceed with confidence.",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="py-24 sm:py-32">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <Reveal>
        <p className="font-eyebrow text-[11px] text-[#928E84]">How it works</p>
        <h2 className="font-display font-medium tracking-tight text-[#141518] text-4xl sm:text-5xl mt-5 max-w-2xl leading-[1.08]">
          Three steps to doing more business.
        </h2>
      </Reveal>

      <div className="mt-16 sm:mt-20 grid md:grid-cols-3 gap-px bg-[#E7E4DC] border border-[#E7E4DC]">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.num} delay={i * 0.12} className="bg-[#FAF9F5]">
            <div data-testid={`how-it-works-step-${c.num}`} className="p-8 sm:p-10 h-full group">
              <div className="flex items-start justify-between">
                <span className="font-display text-6xl text-[#E7E4DC] group-hover:text-[#D4C29E] transition-colors duration-500">
                  {c.num}
                </span>
                <c.icon size={22} className="text-[#928E84] mt-2" strokeWidth={1.5} />
              </div>
              <h3 className="font-display text-2xl sm:text-3xl text-[#141518] mt-8">{c.title}</h3>
              <p className="text-sm sm:text-base text-[#635F57] leading-relaxed mt-4">{c.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
